import { Component, Input, OnInit } from '@angular/core';
import { AppConfigService } from '@app/shared/services/app-config.service';
import { ConnectionService } from '@app/shared/services/connection.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-change-log-template',
  templateUrl: './change-log-template.component.html',
  styleUrls: ['./change-log-template.component.less'],
})
export class ChangeLogTemplateComponent implements OnInit {
  @Input() objectId: number;
  @Input() objectType: number;

  constructor(private connectionService: ConnectionService) {}

  ngOnInit() {
    this.connectionService.fetchData(
      `${AppConfigService.settings.baseUrl}data-api/ChangeLog?filter=ObjectType eq ${this.objectType} AND ObjectId eq ${this.objectId}&orderby=Id desc`,
      (logs: any) => {}
    );
  }
}
